export default __webpack_public_path__ + "c6d04eb41fc61396c8f7b115713b9128.png";